module.exports = __webpack_public_path__ + "static/img/logo-fd.9f4d972.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-fd.png
// module id = mje/
// module chunks = 17